"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTPSA = void 0;
const getNumberProperties_1 = require("./getNumberProperties");
/**
 * Returns the topological polar surface area in angstrom^2
 *
 * @param data Data of a compound data request to the PubChem API
 * @returns Computed Data
 */
function getTPSA(data) {
    const tpsa = (0, getNumberProperties_1.getNumberProperties)(data, 'Topological Polar Surface Area');
    return tpsa;
}
exports.getTPSA = getTPSA;
//# sourceMappingURL=getTPSA.js.map